import {Component} from 'react';
import "./css-files/moneyBuilder.css";
import Button from 'react-bootstrap/Button';
import DropDownOptionCard from '../shared-components/drop_down_option_card';
import TransactionHistoryDisplayCard from './transaction_history_display_card';
import transactionHistoryText from './text/transaction_history_text';
import NumberedListCard from '../game-views/numbered_list_card';

class TransactionHistoryByAccountType extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false, 
            rerender: false
        };
        this.investNameOptionsArr = [];
        this.closedYearOptionsArr = [];
        this.yearFilter = "all years";
        this.nameFilter = "all investments";
        this.historyTranOld = [];
        this.addHistoryButton = true;
        this.displayInfo = false;
        this.initializeInformation();
    }

    initializeInformation(){
        switch (this.props.tranInfo.accountType){
            case "bank":
                this.titleText = "Bank Accounts";
                break;
            case "retirement":
                this.titleText = "Retirement Accounts";
                break;
            case "investments":
                this.titleText = "Investments";
                break;
            default:
                break;
        }
        this.gameYear = this.props.gameDate.split("-")[0];
        const informationTextObj = 
            transactionHistoryText.find(elem => elem.accountType === this.props.tranInfo.accountType);
        this.paragraph1 = informationTextObj.paragraph1;
        this.paragraph2 = informationTextObj.paragraph2;
        this.ulArr = informationTextObj.ulArr;
        this.determineDataClasses();
        this.filterYear = "all";
        this.displayDetailButton = true;
        if (this.props.tranInfo.accountType === "bank" || this.props.tranInfo.accountType === "retirement"){
            if (this.props.savingsExist === false){
                this.displayDetailButton = false;
            }
        }else{
            if (this.props.investmentsExist === false){
                this.displayDetailButton = false;
            }
        }
        this.selectTranHistory();
        this.determineFilterOptions();
    }

    determineDataClasses(){
        this.classSize = "col-sm-8 mt-1";
        this.tableClass = "table table-hover table-no-space mt-4 ";
        this.textClass = "mt-2 text-left mx-4 "
    }
    
    selectTranHistory(){
        this.historyTranArr = this.props.tranInfo.totalArr;
        this.historyTranOut = JSON.parse(JSON.stringify(this.historyTranArr));
        this.filterTransactionHistory(this.filterYear);
        if (this.historyTranOut.length === 0){
            this.filterYear -= 1;
            this.filterTransactionHistory(this.filterYear);
        }
    }
          
    determineFilterOptions(){
        this.tranYearOptionsArr = [];
        for (let i=0; i<this.props.tranInfo.totalArr.length; i++){
            const tranYear = this.props.tranInfo.totalArr[i].tranYear;
            const checkTranYearOptions = 
                this.tranYearOptionsArr.find(elem => elem.value === tranYear)
            if (!checkTranYearOptions){
                let selection = tranYear;
                const tranYearObj = {value: tranYear, selection: selection};
                this.tranYearOptionsArr.push(tranYearObj);
            }
        }
        if (this.tranYearOptionsArr.length > 0){
            const tranYearObj = this.tranYearOptionsArr.find(elem => elem.tranYear === "all");
            if (tranYearObj){
                tranYearObj.selection = "all years";
            }
        }
        this.tranYearOptionsArr.sort((a, b) => (a.value > b.value) ? -1 : 1)
    }   
   
    filterTransactionHistory(filterArg){
        this.filterYear = filterArg;
        if (filterArg === "all"){
            this.historyTranOut = this.historyTranArr.filter(item => item.tranYear === this.filterYear);
        }else{
            this.historyTranOut = this.historyTranArr.filter(item => +item.tranYear === +this.filterYear);
        }
        const historyTranObj = this.historyTranOut.find(item => item.balFwdSw === true);
        this.balFwdSw = false;
        if (historyTranObj){
            this.balFwdSw = true;
        }
        this.setState({rerender: !this.state.rerender});
    }
    
   
    toggleInfoDisplay(){
        this.displayInfo = !this.displayInfo
        this.setState({rerender: !this.state.rerender})
    }

    render() {
        this.yearOptions = this.tranYearOptionsArr.map((optionsList,index) =>
            <DropDownOptionCard options={optionsList} key={index} />
        );
        this.historyTransactionInfo =  this.historyTranOut.map((historyTrans, index) =>
            <TransactionHistoryDisplayCard key={index} tranInfo={historyTrans} 
                savingsClass={this.props.tranInfo.accountType}
                 />
        );
        const listLines = this.ulArr.map((textLine, index) =>
            <NumberedListCard key={index} text={textLine}
                 displayPercent={true}
                />
            );
        const defaultImgSrc = "./assets/" + this.props.tranInfo.imageURL;
    return <>
        <div className="solid-line"></div>
            <div className="custom-header ">
                <h4 className="custom-title">
                    Summary by Transaction Type for {this.titleText}
                </h4>
            </div>
            <div style={{ overflowX: 'hidden' }}>
            
                {this.displayInfo ?
                <>
                    <div className={this.textClass}>{this.paragraph1}</div>
                    <div className="d-flex flex-column">
                    <div className={this.textClass}>{this.paragraph2}</div>
                    {/* Make UL container position-relative */}
                    <div className="position-relative">
                        <ul className="ml-4 bulleted-list"> {/* Add some space for button */}
                            {listLines}
                        </ul>
                        <Button
                            className="btn position-absolute"
                            style={{ bottom: '0.75rem', right: '0.50rem' }} // Adjust spacing
                            variant="outline-info"
                            size="sm"
                            onClick={() => this.toggleInfoDisplay("collapse")} >
                                Collapse
                        </Button>
                    </div>
                    </div>

                </>
                :
                    <div className={this.textClass}>{this.paragraph1}
                            <Button  className="ml-2" variant="outline-info"  size="sm"
                                onClick={() => this.toggleInfoDisplay("learn more")}>
                                Learn More
                            </Button>
                    </div>
                }
                {this.historyTranArr.length === 0 ?
                    <div className= {this.textClass}>
                        <div className="mt-2">
                            You do not currently have any transaction history to report 
                                for {this.titleText}. 
                        </div>
                    </div>
                :
                    <span>
                        <div className="text-right mr-4">
                            <label className="filter-label" htmlFor="investYear">
                                Transaction Year:&nbsp;
                            </label>
                            <select
                                id="investYear"
                                onChange={(val) => this.filterTransactionHistory(val.target.value)}
                                className="filter-select small-select"
                            >
                            {this.yearOptions}
                            </select>
                           
                        </div>
                        <div className = "row">
                            <div className="col-sm-2 mt-4">
                                  <img src={defaultImgSrc} className="card_size_thumbnail_img" alt="logo"/>
                            </div>
                            <div className="col-sm-8">
                                <table className={this.tableClass}>
                                    <tbody>
                                        <tr>
                                            <th className="text-center">Tran Type</th>
                                            <th className="text-center">Tran Year</th>
                                            {this.props.tranInfo.accountType === "retirement"  ?
                                                <th className="text-center">Share Amount</th>
                                            :
                                                <th className="text-center">Tran Amount</th>
                                            }
                                           
                                        </tr>
                                        {this.historyTransactionInfo}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        {this.balFwdSw ?
                        <h6 className="mx-5">These transactions show a summary of your account activity through &nbsp;
                            {this.filterYear}.  Older transactions have been grouped together into a single balance 
                            forward total. 
                        </h6>
                        :
                            null
                        }
                    </span>
                }
                <div className="row">
                    {this.federalIncomeTax   ?
                        <div className="col-sm-7 pr-0 small-text">
                            *** Federal Income Tax amounts are displayed for information. They do 
                            not affect the account balance as the amount has already been paid out
                            of your cash/checking account.
                        </div>
                    :
                        <div className="col-sm-7"></div>
                    }
                    {this.displayDetailButton && this.historyTranArr.length > 0 ?
                        <div className="col-sm-4 text-right px-0 mb-2">
                            <Button
                                variant="primary"
                                size="sm"
                                onClick={() => this.props.displayDetailTranHistory(this.props.tranInfo.accountType)} >
                                    Display Transaction Detail
                            </Button> 
                        </div> 
                    :
                        null
                    }
                </div>
        </div>
            
    </>
    }
       
}

export default TransactionHistoryByAccountType;